import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
  
})
export class FooterComponent implements OnInit {
  
  public parceriaId?: number;

  constructor(private authService: AuthService) { }
   
  ngOnInit() {
      this.parceriaId = this.authService.credentials.contratante.idParceria;
  }

}
